module.exports = "<md-dialog class=\"session-timeout-modal\"> <md-dialog-content> <div class=\"md-dialog-content\"> <h3 class=\"modal__header\">Please log in again</h3> <div> <p>{{'ERRORPAGE.SESSIONTIMEOUT' | translate}}</p> </div> </div> </md-dialog-content> <md-dialog-actions layout=\"row\"> <span flex></span> <md-button class=\"md-raised md-accent\" ng-click=\"close()\" md-autofocus> Log In </md-button> </md-dialog-actions> </md-dialog> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/sessionTimeoutModal/sessionTimeoutModal.html
// module id = 967
// module chunks = 28